// Helpers for resolving observation answers against a rubric's answer-option
// catalog. The backend serializes answer.selected_option as a bare UUID string
// (not a nested object), so the semantic flags (is_positive, is_not_observed)
// have to be looked up by id against rubric.answer_option_sets[].options[].

// { [optionUuid]: option } lookup table for the whole rubric.
export const buildOptionsMap = (rubric) => {
  const map = {};
  (rubric?.answer_option_sets || []).forEach((set) => {
    (set.options || []).forEach((opt) => {
      map[opt.uuid] = opt;
    });
  });
  return map;
};

// Curried classifier: resolves one answer to "pass" / "fail" / "not_observed"
// via the option catalog built above.
export const classifyAnswerWith = (optionsMap) => (answer) => {
  if (!answer || !answer.selected_option) return "not_observed";
  const opt = optionsMap[answer.selected_option];
  if (!opt) return "not_observed";
  if (opt.is_not_observed) return "not_observed";
  if (opt.is_positive) return "pass";
  return "fail";
};
